<template>
  <div>
    <section class="reservation-info" v-if="!isLoading && reservation">
      <div class="container">
        <div class="row">
          <div class="col-sm-7">
            <div class="header--reservation-detail">
              <div class="header--reservation-box">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb mb-35 pz">
                    <li class="breadcrumb-item">
                      <router-link :to="'/job/available'">
                        Available Job
                      </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Details
                    </li>
                  </ol>
                </nav>
                <h4>Provider Jobs Details</h4>
                <div
                  :class="progressClassName"
                  :style="
                    isAirportTransfer && !isArrivedFlight && !isDepartureFlight
                      ? 'position: relative; bottom: 5px'
                      : ''
                  "
                ></div>
                <div class="table-legend">
                  <ul>
                    <li v-if="isAirportTransfer && isArrivedFlight">
                      <i class="ic-flight-icon"></i>Airport Transfer
                    </li>
                    <li v-if="isAirportTransfer && isDepartureFlight">
                      <i class="ic-flight-departure-icon"></i>Airport Transfer
                    </li>
                    <li
                      style="display: flex"
                      v-else-if="
                        isAirportTransfer &&
                        !isArrivedFlight &&
                        !isDepartureFlight
                      "
                    >
                      <i class="ic-car-alt">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 1200 1200"
                        >
                          <path
                            fill="currentColor"
                            d="m214.662 100.752l-75.97 316.401H0v91.456h47.573v590.639h136.569v-96.685h831.716v96.685h136.496V508.609H1200v-91.456h-138.692l-75.971-316.401H214.662zm40.474 61.52h689.713l61.187 254.887H193.934l61.186-254.887h.016zm-168.048 423.7l190.44 70.329v91.384l-190.44-70.329v-91.384zm1025.73 0v91.384l-190.362 70.329v-91.456l190.362-70.257zM415.833 825.036h368.193v91.384H415.833v-91.384z"
                          />
                        </svg>
                      </i>
                      Airport Transfer
                    </li>
                    <li v-else-if="!isAirportTransfer">
                      <i class="ic-time"></i>Hourly Booking
                    </li>
                  </ul>
                </div>
              </div>
              <div class="label-group" v-if="userType !== 'ProviderUser'">
                <div class="label">Payment Status</div>
                <div class="label-title">
                  <span
                    v-if="reservation.paymentStatus === 'Complete'"
                    class="--green35"
                    >Completed</span
                  >
                  <span v-else class="sts-danger">{{
                    humanize(reservation.paymentStatus)
                  }}</span>
                </div>
              </div>
              <div class="label-group" v-if="userType !== 'ProviderUser'">
                <div class="label">Payment Method</div>
                <div class="label-title">
                  <span>{{
                    humanize(reservation.paymentMethodDescription)
                  }}</span>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Code</div>
                <div class="label-title">
                  <span>{{ reservation.code }}</span>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Date</div>
                <div class="label-title">
                  <span>{{ reservation.reservationDate.stringFullDate }}</span>
                </div>
              </div>
            </div>
            <div class="mb-25">
              <div class="row">
                <div class="col-sm-10">
                  <div class="dropandpickup">
                    <div class="col-sm-12 pz mb-15">
                      <div class="location-pick-up">
                        {{ reservation.pickUpLocation.name }}
                      </div>
                      <div class="row mt-10">
                        <div class="col-sm-5 prz">
                          <div class="rent-date">
                            {{ reservation.pickUpDate.day }}
                            {{ reservation.pickUpDate.stringShortMonth }}
                          </div>
                        </div>
                        <div class="col-sm-7 text-right">
                          <div class="rent-time">
                            <i class="ic-time"></i>
                            {{ reservation.pickUpDate.stringHour }}:{{
                              reservation.pickUpDate.stringMinute
                            }}
                            <span class="utc-zone"
                              >({{ reservation.pickUpDate.offsetName }})</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-12 pz pt-10 divider-top-blue">
                      <div class="location-drop-off text-right">
                        {{ reservation.dropOffLocation.name }}
                      </div>
                      <div class="row mt-10">
                        <div class="col-sm-5 prz">
                          <div class="rent-date">
                            {{ reservation.dropOffDate.day }}
                            {{ reservation.dropOffDate.stringShortMonth }}
                          </div>
                        </div>
                        <div class="col-sm-7 text-right">
                          <div class="rent-time">
                            <i class="ic-time"></i>
                            {{ reservation.dropOffDate.stringHour }}:{{
                              reservation.dropOffDate.stringMinute
                            }}
                            <span class="utc-zone"
                              >({{ reservation.dropOffDate.offsetName }})</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-2 plz text-center">
                  <div class="map-capture">
                    <!-- <img :src="cdn + '/images/capture-map.png'" alt /> -->
                  </div>
                  <div class="btn btn-flat" @click.prevent="openMapModal()">
                    View Map
                  </div>
                </div>
              </div>
            </div>

            <div class="body--reservation-detail">
              <div class="row">
                <div
                  :class="
                    !sameBookerAndPassenger
                      ? 'col-sm-6 divider-right'
                      : 'col-sm-6'
                  "
                >
                  <i class="ic-businessmen pull-left mr-10 --green"></i>
                  <h4 class="--green">Passenger Details</h4>
                  <!-- <div class="label-group">
                    <div class="label">Company</div>
                    <div class="label-title">
                      {{
                        reservation.customers[0].companyName
                          ? reservation.customers[0].companyName
                          : "N/A"
                      }}
                    </div>
                  </div> -->
                  <div class="label-group">
                    <div class="label">Name</div>
                    <div class="label-title">
                      {{ reservation.customers[0].title }}.
                      {{ reservation.customers[0].fullName }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Phone</div>
                    <div class="label-title">
                      {{
                        reservation.customers[0].phoneCode &&
                        reservation.customers[0].phoneNumber
                          ? `(+${reservation.customers[0].phoneCode}) ${reservation.customers[0].phoneNumber}`
                          : "N/A"
                      }}
                    </div>
                  </div>
                  <div class="label-group" v-if="userType !== 'ProviderUser'">
                    <div class="label">Email</div>
                    <div class="label-title">
                      {{
                        reservation.customers[0].email
                          ? reservation.customers[0].email
                          : "N/A"
                      }}
                    </div>
                  </div>
                  <template>
                    <div
                      class="label-group"
                      v-if="reservation.numberOfPassengers"
                    >
                      <div class="label">Number of Passengers</div>
                      <div class="label-title">
                        {{ reservation.numberOfPassengers }}
                      </div>
                    </div>
                    <div
                      class="label-group"
                      v-if="reservation.numberOfSmallLuggages"
                    >
                      <div class="label">Number of Small Luggages</div>
                      <div class="label-title">
                        {{ reservation.numberOfSmallLuggages }}
                      </div>
                    </div>
                    <div
                      class="label-group"
                      v-if="reservation.numberOfBigLuggages"
                    >
                      <div class="label">Number of Big Luggages</div>
                      <div class="label-title">
                        {{ reservation.numberOfBigLuggages }}
                      </div>
                    </div>
                  </template>
                  <!-- <div class="mt-30">
                    <button class="btn btn-secondary">Email Job Status</button>
                    <button class="btn btn-secondary">SMS Job Status</button>
                  </div> -->
                </div>
                <div
                  :class="
                    sameBookerAndPassenger
                      ? 'col-sm-6 text-right divider-left'
                      : 'col-sm-6 text-right'
                  "
                  v-if="!sameBookerAndPassenger && userType !== 'ProviderUser'"
                >
                  <h4>Booker</h4>
                  <div class="label-group">
                    <div class="label">Name</div>
                    <div class="label-title">
                      {{ reservation.booker.title }}.
                      {{ reservation.booker.fullName }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Phone</div>
                    <div class="label-title">
                      {{
                        reservation.booker.phoneCode &&
                        reservation.booker.phoneNumber
                          ? `(+${reservation.booker.phoneCode}) ${reservation.booker.phoneNumber}`
                          : "N/A"
                      }}
                    </div>
                  </div>
                  <div class="label-group" v-if="userType !== 'ProviderUser'">
                    <div class="label">Email</div>
                    <div class="label-title">
                      {{
                        reservation.booker.email
                          ? reservation.booker.email
                          : "N/A"
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="passenger-flight-info">
              <div v-if="reservation.flightInfo">
                <h4>Passenger Flight Info</h4>
                <div class="row">
                  <div class="col-sm-8">
                    <div class="--green passenger__flight">
                      {{ reservation.flightInfo.carrierName }}
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="passenger__flight-number">
                      {{ reservation.flightInfo.carrierCode }}-{{
                        reservation.flightInfo.flightNumber
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="reservation.noteToDriver">
                <h4>Notes to Driver</h4>
                <div class="passenger-notes">
                  {{ reservation.noteToDriver }}
                </div>
              </div>
              <div
                v-if="
                  isAllowViewCustomerNotes &&
                  (reservation.passengerNameRecord ||
                    reservation.project ||
                    reservation.additionalRequest)
                "
                style="border-top: 0.5px solid #999"
              >
                <h4 style="margin-top: 20px">Customer Notes</h4>
                <div class="body--reservation-detail additional-table">
                  <div class="row">
                    <div class="col-sm-12">
                      <div
                        class="label-group"
                        v-if="reservation.passengerNameRecord"
                      >
                        <div class="label">PNR/Client Booking No.</div>
                        <div class="label-title">
                          {{ reservation.passengerNameRecord }}
                        </div>
                      </div>
                      <div class="label-group" v-if="reservation.project">
                        <div class="label">Project Name</div>
                        <div class="label-title">
                          {{ reservation.project }}
                        </div>
                      </div>
                      <div
                        class="label-group"
                        v-if="reservation.additionalRequest"
                      >
                        <div class="label">Additional Request</div>
                        <div class="label-title">
                          {{ reservation.additionalRequest }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style="border-top: 0.5px solid #999"
                v-if="isAllowViewAdminNotes && reservation.adminNotes"
              >
                <h4 style="margin-top: 20px">Admin Notes</h4>
                <div class="admin-notes">
                  {{ reservation.adminNotes }}
                </div>
              </div>
            </div>
            <div class="box-addons mt-20">
              <div class="panel-group" id="accordion">
                <div class="panel panel-default">
                  <div class="panel-heading text-center">
                    <h4 class="panel-title">
                      <a
                        class="--green"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        href="#collapse1"
                      >
                        <i class="ic-History mr-5"></i>Reservation History
                      </a>
                    </h4>
                  </div>
                  <div id="collapse1" class="panel-collapse collapse">
                    <div class="panel-body">
                      <div class="trip-info">
                        <div
                          v-for="(history, index) in reservation.histories"
                          :key="index"
                        >
                          <div class="col-sm-3">
                            <div class="time__depart">
                              <div class="time_Is">
                                {{ history.createdDate.stringHour }}:{{
                                  history.createdDate.stringMinute
                                }}:{{
                                  `${
                                    history.createdDate.second.toString()
                                      .length > 1
                                      ? ""
                                      : "0"
                                  }${history.createdDate.second}`
                                }}
                              </div>
                              <div class="date_Is">
                                ({{ history.createdDate.offsetName }})
                              </div>
                              <div class="date_Is">
                                {{ history.createdDate.stringDate }}
                                {{ history.createdDate.stringShortMonth }}
                                {{ history.createdDate.year }}
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-9">
                            <div
                              :class="[
                                index === reservation.histories.length - 1
                                  ? 'end-time-stamp'
                                  : 'time-stamp',
                                history.event.toLowerCase().includes('dropped')
                                  ? 'dropped'
                                  : '',
                              ]"
                            >
                              <div class="stamp-status --green">
                                {{ humanize(history.eventText) }}
                              </div>
                              <div
                                v-if="
                                  userType !== 'ProviderUser' ||
                                  (humanize(history.eventText) !== 'Quoted' &&
                                    humanize(history.eventText) !== 'Paid')
                                "
                                class="stamp-desc"
                                v-html="getEventDescription(history)"
                              ></div>
                              <div v-if="isButtonShow(history.description)">
                                <button
                                  class="btn btn-default"
                                  type="button"
                                  @click="getImage(history)"
                                >
                                  <span>Show</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-5">
            <div class="price-detail-header">
              <div
                class="grand-total pbz"
                :style="ancillaryTotal <= 0 ? 'border-top: 1px solid #ddd' : ''"
              >
                <table
                  class="table table-amount"
                  :style="ancillaryTotal <= 0 ? 'margin-top: 0' : ''"
                >
                  <thead
                    v-if="
                      reservation.grandTotal > 0 && reservation.currencyCode
                    "
                  >
                    <tr>
                      <th class="text-left --green" style="border: none">
                        Total Amount
                      </th>
                      <th class="text-right" style="border: none">
                        <strong
                          >{{ reservation.currencyCode }}
                          {{
                            $currencyFormat(
                              reservation.currencyCode,
                              reservation.grandTotal
                            )
                          }}</strong
                        >
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <tr>
                      <td class="text-left">
                        <span>Base Fare</span>
                      </td>
                      <td class="text-right">
                        <strong
                          >{{ reservation.currencyCode }}
                          {{
                            $currencyFormat(
                              reservation.currencyCode,
                              reservation.baseFare
                            )
                          }}</strong
                        >
                      </td>
                    </tr> -->
                    <tr v-if="reservation.ancillaries.length">
                      <td class="text-left">Ancillary</td>
                      <td class="text-right" v-if="ancillaryTotal > 0">
                        <strong
                          >{{ reservation.currencyCode }}
                          {{
                            $currencyFormat(
                              reservation.currencyCode,
                              ancillaryTotal
                            )
                          }}</strong
                        >
                      </td>
                    </tr>
                    <tr v-if="reservation.ancillaries.length">
                      <td colspan="2">
                        <ul class="table-list">
                          <li
                            v-for="(
                              ancillary, index
                            ) in reservation.ancillaries"
                            :key="index"
                          >
                            {{ ancillary.name }}<span>x{{ ancillary.qty }}</span
                            ><span class="value" v-if="ancillaryTotal > 0"
                              >{{ reservation.currencyCode }}
                              {{
                                $currencyFormat(
                                  reservation.currencyCode,
                                  ancillary.rate
                                )
                              }}</span
                            >
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <!-- <tr v-if="surchargeTotal > 0">
                      <td class="text-left">Surcharge</td>
                      <td class="text-right">
                        <strong
                          >{{ reservation.currencyCode }}
                          {{
                            $currencyFormat(
                              reservation.currencyCode,
                              surchargeTotal
                            )
                          }}</strong
                        >
                      </td>
                    </tr>
                    <tr v-if="reservation.surcharges.length">
                      <td colspan="2">
                        <ul class="table-list">
                          <template
                            v-for="(sur, index) in reservation.surcharges"
                          >
                            <li :key="index" v-if="sur.rate > 0">
                              {{ sur.name }}
                              <span class="value">
                                <div class="text-right">
                                  {{ sur.currency }}
                                  {{ $currencyFormat(sur.currency, sur.rate) }}
                                </div>
                              </span>
                            </li>
                          </template>
                        </ul>
                      </td>
                    </tr> -->
                    <!-- <tr v-if="reservation.postBookingExtras.length">
                      <td class="text-left">Post-Booking Extras</td>
                      <td class="text-right" v-if="postBookingExtrasTotal > 0">
                        <strong
                          >{{ reservation.currencyCode }}
                          {{
                            $currencyFormat(
                              reservation.currencyCode,
                              postBookingExtrasTotal
                            )
                          }}</strong
                        >
                      </td>
                    </tr>
                    <tr v-if="reservation.postBookingExtras.length">
                      <td colspan="2">
                        <ul class="table-list">
                          <li
                            v-for="(
                              extra, index
                            ) in reservation.postBookingExtras"
                            :key="index"
                          >
                            <template v-if="extra.rate > 0">
                              {{ extra.name
                              }}<span v-if="extra.qty > 0"
                                >x{{ extra.qty }}</span
                              ><span class="value"
                                >{{ extra.currency }}
                                {{
                                  $currencyFormat(extra.currency, extra.rate)
                                }}</span
                              >
                            </template>
                          </li>
                        </ul>
                      </td>
                    </tr> -->
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="reservation.vehicle" class="reservation-summary--small">
              <div class="brand-box" v-if="reservation.vehicle">
                <div class="type-car" v-if="reservation.vehicle.className">
                  {{ reservation.vehicle.className }}
                </div>
                <div class="cars-brand">
                  {{ reservation.vehicle.factoryName }}
                  {{ reservation.vehicle.brandName }}
                  {{
                    reservation.vehicle.plateNumber
                      ? `(${reservation.vehicle.plateNumber})`
                      : ""
                  }}
                  <span class="cars-brand-equivalent">or equivalent</span>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="capacity-seat" v-if="hasPaxCapacity">
                      Pax Capacity {{ reservation.vehicle.feature.paxCapacity }}
                    </div>
                    <div
                      class="capacity-large-baggage"
                      v-if="hasLargeBaggageCapacity"
                    >
                      Large Bag. Capacity x{{
                        reservation.vehicle.feature.largeBaggageCapacity
                      }}
                    </div>
                    <div
                      class="capacity-baggage"
                      v-if="hasSmallBaggageCapacity"
                    >
                      Small Bag. Capacity x{{
                        reservation.vehicle.feature.smallBaggageCapacity
                      }}
                    </div>
                    <!-- <div
                      class="transmission-automatic"
                      v-if="isAutomaticTransmission"
                    >
                      Automatic Transmission
                    </div>
                    <div
                      class="transmission-manual"
                      v-else-if="!isAutomaticTransmission"
                    >
                      Manual Transmission
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="cRow" v-if="reservation.vehicle">
                <div class="col-sm-12">
                  <img
                    :src="
                      reservation.vehicle.imageUri
                        ? reservation.vehicle.imageUri
                        : cdn + '/images/vehicle-dummy.png'
                    "
                    alt
                    class="cars-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Start: Modal -->
    <div class="modal fade" role="dialog" ref="mapmodal">
      <div class="modal-dialog modal-lg">
        <div class="modal-header" style="padding-bottom: 10px">
          <div class="pull-right">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              <i class="ic-close"></i>
            </button>
          </div>
        </div>
        <div class="modal-content">
          <div class="modal-body">
            <mapModal />
          </div>
        </div>
      </div>
    </div>
    <!-- End: Modal -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import numeral from "numeral";
import _ from "lodash";
import mapModal from "@/components/shared/MapModal";
import availableJobService from "@/services/job/availableJobService";
import maverickDirection from "@/plugins/google/direction.js";
import {
  allowToViewAdminNotes,
  allowToViewCustomerNotes,
} from "@/helpers/userHelper.js";

export default {
  components: {
    mapModal,
  },
  data() {
    return {
      isLoading: true,
      msg: "Please wait",
      moneyFormat: null,
      reservation: null,
      direction: null,
      allPermissions: [],
      sameBookerAndPassenger: false,
      userType: "Unspecified",
      allServices: null,
    };
  },
  computed: {
    isAllowViewAdminNotes: function () {
      return allowToViewAdminNotes(this.allServices);
    },
    isAllowViewCustomerNotes: function () {
      return allowToViewCustomerNotes(this.allServices);
    },
    ancillaryTotal: function () {
      let total = 0;
      if (this.reservation && this.reservation.ancillaries.length) {
        this.reservation.ancillaries.forEach(
          (val) => (total += val.qty * val.rate)
        );
      }
      return total;
    },
    progressClassName: function () {
      if (this.reservation) {
        switch (this.reservation.progress.toLowerCase()) {
          case "open":
            return "sts_job-open";
          case "run":
            return "sts_job-run";
          case "done":
            return "sts_job-done";
          case "close":
            return "sts_job-closed";
          case "abort":
            return "sts_job-aborted";
          case "rescueoperation":
            return "rescue_operation";
        }
      }
      return "";
    },
    isAutomaticTransmission: function () {
      return (
        this.reservation &&
        this.reservation.vehicle &&
        this.reservation.vehicle.feature &&
        this.reservation.vehicle.feature.transmission.toLowerCase() === "at"
      );
    },
    hasPaxCapacity: function () {
      return (
        this.reservation &&
        this.reservation.vehicle &&
        this.reservation.vehicle.feature &&
        this.reservation.vehicle.feature.paxCapacity &&
        parseInt(this.reservation.vehicle.feature.paxCapacity) > 0
      );
    },
    hasLargeBaggageCapacity: function () {
      return (
        this.reservation &&
        this.reservation.vehicle &&
        this.reservation.vehicle.feature &&
        this.reservation.vehicle.feature.largeBaggageCapacity &&
        parseInt(this.reservation.vehicle.feature.largeBaggageCapacity) > 0
      );
    },
    hasSmallBaggageCapacity: function () {
      return (
        this.reservation &&
        this.reservation.vehicle &&
        this.reservation.vehicle.feature &&
        this.reservation.vehicle.feature.smallBaggageCapacity &&
        parseInt(this.reservation.vehicle.feature.smallBaggageCapacity) > 0
      );
    },
    isAirportTransfer: function () {
      return (
        this.reservation &&
        this.reservation.serviceType !== "" &&
        this.reservation.serviceType.toLowerCase() === "airporttransfer"
      );
    },
    isArrivedFlight: function () {
      return (
        this.reservation &&
        this.reservation.pickUpLocation &&
        this.reservation.pickUpLocation.isAirport
      );
    },
    isDepartureFlight: function () {
      return (
        this.reservation &&
        this.reservation.dropOffLocation &&
        this.reservation.dropOffLocation.isAirport
      );
    },
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    cdn: function () {
      return process.env.VUE_APP_CDN;
    },
    surchargeTotal: function () {
      return (
        this.reservation.surcharges.length &&
        this.reservation.surcharges.reduce(
          (accum, item) => accum + item.rate,
          0
        )
      );
    },
    postBookingExtrasTotal: function () {
      return (
        this.reservation.postBookingExtras.length &&
        this.reservation.postBookingExtras.reduce(
          (accum, item) => accum + item.rate,
          0
        )
      );
    },
  },
  async created() {
    this.$helper.scrollTop();
    await this.getUserType();
    const profile = await this.$store.dispatch("user/getProfile");
    this.allServices = profile.services;
    const permissions = profile.services["AvailableJob"];

    if (permissions) {
      this.allPermissions = permissions;
    }

    if (this.isAllowToRead) {
      await this.getDetails();
    } else {
      this.$router.push({ path: "/unauthorized" });
    }
  },
  mounted() {
    if (!this.direction) {
      this.direction = new maverickDirection({ mapId: "map" });
    }
  },
  methods: {
    startLoader() {
      this.isLoading = true;
    },
    stopLoader() {
      this.isLoading = false;
    },
    async getDetails() {
      const response = await availableJobService.getJobDetails(
        this.$route.params.id,
        this.startLoader,
        this.stopLoader
      );

      if (response.isSuccess) {
        this.reservation = response.data;
        this.moneyFormat = response.data.moneyFormat;

        const { booker, customers } = this.reservation;
        const bookerData = {
          name: booker.fullName,
          email: booker.email,
          phonenumber: `${booker.phoneCode}${booker.phoneNumber}`,
        };
        const passengerData = {
          name: customers[0].fullName,
          email: customers[0].email,
          phonenumber: `${customers[0].phoneCode}${customers[0].phoneNumber}`,
        };
        this.sameBookerAndPassenger = _.isEqual(bookerData, passengerData);
      }
    },
    async getUserType() {
      const profile = await this.$store.dispatch("user/getProfile");
      this.userType = profile.userType;
    },
    async openMapModal() {
      if (this.reservation.logLocations) {
        await this.direction.display(this.reservation.logLocations);
      }
      $(this.$refs.mapmodal).modal();
    },
    isButtonShow(history) {
      if (history == null || history == undefined) {
        return false;
      }

      var historySplit = history.split(/:(.+)/);
      if (historySplit[0] === "link") {
        return true;
      } else {
        return false;
      }
    },
    humanize(value) {
      return this.$helper.humanize(value);
    },
    getEventDescription(history) {
      return this.$helper.getEventDescription(history, this.userType);
    },
  },
};
</script>

<style scoped>
.gmap-point-container {
  height: 580px !important;
}
.table.table-amount tbody td:last-child {
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/job/availableJob/AvailableJobDetail.vue